import { FormField } from '../../type';
import { isFileField } from './types';
import { toFiles } from './toFiles';

/**
 * Pulls the picked files out of the form values: they travel to the server
 * as `FormData` keyed by field name, everything else as submission data.
 */
export const splitFiles = (
  values: Record<string, unknown>,
  fields: FormField[],
) => {
  const fileFieldNames = new Set(
    fields.filter(isFileField).map((field) => field.name),
  );
  const files = new FormData();
  const rest: Record<string, unknown> = {};

  Object.entries(values).forEach(([name, value]) => {
    if (!fileFieldNames.has(name)) {
      rest[name] = value;
      return;
    }
    toFiles(value).forEach((file) => files.append(name, file));
  });

  const hasFiles = !files.keys().next().done;
  return { values: rest, files: hasFiles ? files : undefined };
};
